import { TranslateService } from '@ngx-translate/core';

/**
 * Returns translated value for a shape default text key if available.
 * Falls back to original when key is missing.
 */
export function translateShapeText( translate: TranslateService, text: string ): string {
    if ( typeof text !== 'string' || !text ) { return text; }
    const translated = translate.instant( 'SHAPES.' + text );
    if ( typeof translated === 'string' && !translated.startsWith( 'SHAPES.' )) {
        return translated;
    }
    return text;
}

/**
 * Mutates the provided text object if it has a single-run content array.
 */
export function translateSingleRunContent( translate: TranslateService, textObj: any ): void {
    const run = textObj?.content?.length === 1 ? textObj.content[0] : null;
    if ( run && typeof run.text === 'string' ) {
        const newText = translateShapeText( translate, run.text );
        if ( newText !== run.text ) {
            run.text = newText;
        }
    }
}

